import axios, { getAuthHeaders } from './config'
export default {

    all: function() {
        return axios.get('/permissions', {
            headers: getAuthHeaders()
        })
    },
    groupPermissions: function() {
        return axios.get('/group-permissions', {
            headers: getAuthHeaders()
        })
    },
    permissionsUser: function(userId) {
        return axios.get(`/permissions/user/${userId}`, {
            headers: getAuthHeaders()
        });
    }
}